<template>
    <div class="page-main container">
        <lotteryHeader :lottery="lottery"></lotteryHeader>
        <div class="main-bd">
            <div class="main-bd_left">
                <div class="hd">
                    <div class="tit" @click="clickAllList()">
                        全部计划
                    </div>
                    <div class="operation">
                        <span @click="clickRankingList()" :class="list_type == 1 ? 'active' : ''"><i class="icon-ph"></i>计划排行</span>
                        <!-- <span @click="clickCollectionList()" :class="list_type == 2 ? 'active' : ''"><i class="icon-sc"></i>我的收藏</span> -->
                    </div>
                </div>
                <div class="bd">
                    <template v-if="list_type == 1">
                        <div class="line-list">
                            <div class="line-list_hd ranking-hd">
                                <div class="col-1">排名</div>
                                <div class="col-2">计划名称</div>
                                <div class="col-3">点击量</div>
                                <div class="col-4">查看</div>
                                <!-- <div class="col-5">收藏</div> -->
                                <div class="col-last"></div>
                            </div>
                            <div class="line-list_bd scrollbar ranking-bd">
                                <div class="item" v-for="(item,index) in plan_ranking_list">
                                    <div class="col-1">
                                        <span class="ball">{{ index + 1 }}</span>
                                    </div>
                                    <div class="col-2">{{item.name}}</div>
                                    <div class="col-3">{{item.click_num}}</div>
                                    <div class="col-4">
                                        <span class="b0 b1" @click="clickPlan(item,index)"><i class="el-icon-search"></i>查看</span>
                                    </div>
                                    <!-- <div class="col-5">
                                        <span class="b0 b2" @click="clickCollect(item,index)"><i class="el-icon-star-on"></i>{{item.is_collect == 1 ? '已收藏' : '收藏'}}</span>
                                    </div> -->
                                    <div class="col-last"></div>
                                </div>
                                
                            </div>
                        </div>
                    </template>
                    <template v-else-if="list_type == 2">
                        <div class="line-list">
                            <div class="line-list_hd ">
                                <div class="col-1">排名</div>
                                <div class="col-2">计划名称</div>
                                <div class="col-3">点击量</div>
                                <div class="col-4">查看</div>
                                <div class="col-5">收藏</div>
                                <div class="col-last"></div>
                            </div>
                            <div class="line-list_bd scrollbar ">
                                <div class="item" v-for="(item,index) in collect_list">
                                    <div class="col-1">
                                        <span class="ball">{{ index + 1 }}</span>
                                    </div>
                                    <div class="col-2">{{item.plan_name}}</div>
                                    <div class="col-3">{{item.click_num}}</div>
                                    <div class="col-4">
                                        <span class="b0 b1" @click="clickCollectionPlan(item,index)"><i class="el-icon-search"></i>查看</span>
                                    </div>
                                    <div class="col-5">
                                        <span class="b0 b2" @click="clickCollectClear(item,index)"><i class="el-icon-delete"></i>删除</span>
                                    </div>
                                    <div class="col-last"></div>
                                </div>
                                
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <div class="list scrollbar">
                            <span @click="clickPlan(item,index)" class="item" :class="plan_active_index == index ? 'active' : ''" v-for="(item,index) in plan_list" v-show="index >= paging.begin_index  && index < paging.end_index ">{{item.name}}</span>
                        </div>
                        <div class="pagination">  
                            <div class="l">
                                <span>共<b>{{paging.count}}</b>页</span>
                                <span>当前第<b>{{paging.page}}</b>页</span>
                            </div>
                            <div class="r">
                                <button class="button-1" @click="clickPaging('first')">首页</button>
                                <button class="button-1" @click="clickPaging('prev')">上页</button>
                                <button class="button-1" @click="clickPaging('next')">下页</button>
                                <button class="button-1" @click="clickPaging('last')">末页</button>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
            <div class="main-bd_right">
                <div class="hd">
                    <div class="l">
                        <el-select v-model="plan_wanfa_value" style="width:150px;" @change="changePanwanfa">
                            <el-option
                                v-for="item in plan_wanfa_options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                        </el-select>
                    </div>
                    <div class="r">
                        <button class="button-2" @click="clickCopy('plan')">复制计划</button>
                        <button class="button-2" @click="clickCopy('number')">复制号码</button>
                        <button class="button-2" @click="clickRefresh"><i class="el-icon-refresh-left"></i>刷新</button>
                        <!-- <button class="button-2" @click="clickCollect2"><i class="el-icon-star-on"></i>收藏</button> -->
                    </div>
                </div>
                <div class="bd " style="height:540px;position: relative;">
                    <div class="adv_right" v-if="adv.ad_img">
                        <a :href="adv.ad_url" target="_block">
                            <img class="adv_img" :src="adv.ad_img" alt="" srcset="">
                        </a>
                        <img class="adv_close" :src="adv.adx_img" alt="" @click="adv.ad_img = ''">
                    </div>
                    <div class="scrollbar">
                        <div v-for="(item,index) in detail_list" class="item">
                            <p v-if="item.scope">
                                <template v-if="item.more">
                                    {{item.scope}}期 
                                    【{{item.plan_name}}】
                                    {{item.wanfa_name}} &nbsp;
                                    【{{item.more}}注】
                                    {{item.now_scope}}期 &nbsp;
                                    {{item.opencode}} &nbsp;
                                    {{item.result}}
                                    <template v-if="item.wait == '进行中'">
                                        <span class="line"></span>
                                        {{item.randnum}}
                                        <span class="line"></span>
                                    </template>
                                </template>
                                <template v-else>
                                    {{item.scope}}期 
                                    【{{item.plan_name}}】
                                    {{item.wanfa_name}} &nbsp;
                                    【{{item.randnum}}】
                                    {{item.now_scope}}期 &nbsp;
                                    {{item.opencode}} &nbsp;
                                    {{item.result}}
                                </template>
                            </p>
                            <p v-else>
                                -----------------------------
                            </p>                            
                        </div>
                    </div>
                </div>
                <!-- <div class="ft">
                    正确率<span>93%</span>，最大连中<span>17</span>个，最大连错<span>2</span>个
                </div> -->
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { getPlanlaborIndex, getPlanlabor, getPlanlaborDetail, postPlanlaborCollectplan, getPlanlaborCollect  } from '@/api/planlabor.js';
    import { get_random_num } from '@/utils/common.js'
    import { getAds } from '@/api/config.js';
    import lotteryHeader from '@/components/common/lotteryHeader.vue'
    export default {
        components: {
            lotteryHeader
        },
        data() {
            return {
                all_lottery:[],
                loty: "",
                lottery: {},//当前彩种
                plan:{},//当前计划
                plan_active_index: -1,
                plan_list: [],//全部计划
                plan_ranking_list: [],//全部计划-排行
                plan_ranking_active_index: -1,
                collect_list: [],//我的收藏
                paging: {
                    page: 0,
                    limit: 60,
                    count: 0,
                    begin_index: 0,
                    end_index: 60
                },
                plan_count: 0,//全部计划
                plan_page: 0,//全部计划
                detail_list:[],//筛选后 - 计划详情列表
                detail_list_all: [],//全部 - 计划详情列表
                list_type: 0,//0全部 1.排行  2 收藏
                wanfa_options: [],
                wanfa_value: '',
                sound_status: true,
                copy_number: "",
                copy_plan: "",
                plan_wanfa_options: [],
                plan_wanfa_value: "",
                issue_expect : "", //正在开奖的 期
                adv :{
                }
            };
        },
        created() {
            //奖期变化 获取最新计划
            this.$eventBus.$on('lotteryIssue',(res)=>{
                // if(res.issue.next_except) {
                //     let issue = res.issue, arr = (issue.next_except + "").split('-');
                //     let except = arr.length > 1 ? arr[1] : arr[0];
                //     this.issue_expect = except;
                // }
                //首次不触发
                if(res.countdown > 1) {
                    this.getPlanlaborDetail();
                }
            });

            getAds().then((response)=>{
                if (response.data.code == 200) {
                    let data = response.data.data;
                    if(data && data.adx_img && Number(data.is_open) === 1) {
                        this.adv = response.data.data;
                    }
                }
            });
        },
        watch:{
            $route: {
                handler: function(){
                    let loty = this.$route.params.loty;
                    if (loty && loty != 'index') {
                        this.loty = loty;
                    } else {
                        this.loty = "";
                    }
                    this.init();
                },
                immediate: true
            },
            lottery_config:{
                handler: function(val){
                    if (val && val.length > 0) {
                        this.init();
                    }
                }
            },
            plan_wanfa_value: {
                 handler: function(val){
                    this.filterPlanlaborDetail()
                }
            }
        },
        computed: {
            ...mapGetters(['lottery_config','lottery_all','token','expire_time'])
        },
        methods: {
            init() {
                if(this.lottery_config.length > 0 && this.lottery_config[0].list.length > 0) {
                    let lottery_data = undefined;
                    if(this.loty) {
                        lottery_data = this.lottery_all[this.loty];                        
                    }                    
                    if (lottery_data == undefined) {
                        this.lottery = this.lottery_config[0].list[0];                        
                    } else {
                        this.lottery = lottery_data;
                    }
                    this.default_loty = this.lottery_config[0].list[0];
                    if (this.default_loty.loty != this.lottery.loty) {
                        // if (this.token == undefined || this.token == "") {
                            if (0>1) {
                            this.lottery.loty = this.default_loty.loty;
                            this.$alert('用户登录查看更多计划!', '提示', {
                                confirmButtonText: '确定',
                                callback: action => {
                                    ;
                                }
                            });
                            this.$router.push('/index/' + this.default_loty.loty);
                            return false;
                        } else if(this.verifyExpiretime()) {
                            this.lottery.loty = this.default_loty.loty;
                            return false;
                        }
                    }
                    this.getPlanlaborIndex(this.lottery.loty);
                    this.getPlanlabor(this.lottery.loty);
                }
            },
            changePanwanfa(val,old) {
            },
            verifyExpiretime() {
                if (this.token && this.expire_time) {
                    //当前时间戳
                    let now_timestamp = Date.parse(new Date()) / 1000;
                    if(now_timestamp > Number(this.expire_time)) {
                        this.$confirm('会员到期!查看更多计划需要充值会员', '提示', {
                            confirmButtonText: '充值',
                            cancelButtonText: '关闭',
                            type: 'warning'
                        }).then(() => {
                            this.$router.push('/member/recharge')
                        }).catch(() => {
                            this.$router.push('/index/' + this.default_loty.loty);          
                        });
                        return true;
                    }                    
                }
                return false;
            },
            clickPlan(item,index){
                this.plan_active_index = this.list_type == 1 ? item.index : index;
                this.plan_ranking_active_index = this.list_type == 1 ? index : -1;
                this.plan = item;
                this.getPlanlaborDetail();
            },
            clickCollectionPlan(item){     
                let exists = false;
                for(let i=0; i < this.plan_list.length; i++) {
                    if (this.plan_list[i].id == item.collect_id) {
                        this.plan_active_index = i;
                        this.plan = this.plan_list[i];
                        exists = true;
                        break;
                    }
                }
                //收藏的计划 不在 计划列表
                if (exists === false) {
                    this.plan.id = item.collect_id;
                    this.plan.name = item.plan_name;
                    this.plan_active_index = -1;
                }
                this.getPlanlaborDetail();
            },            
            clickSound() {
                this.sound_status = !this.sound_status;
            },
            clickAllList() {
                this.list_type = 0;
            },
            clickRankingList() {
                this.list_type = this.list_type === 1 ? 0 : 1;
                this.plan_ranking_active_index = -1;
            },
            clickCollectionList() {
                this.list_type = this.list_type === 2 ? 0 : 2;
                this.getPlanlaborCollect();
            },
            clickRefresh() {
                this.getPlanlaborDetail();
            },
            clickCollect2() {
                this.clickCollect({
                    id: this.plan.id,
                    name: this.plan.name
                }, this.plan_ranking_active_index)
            },
            clickCollect(item,index = -1) {
                //已收藏 =取消
                let is_collect = item.is_collect == 1 ? 0 : 1;
                let param = {
                    loty: this.lottery.loty,
                    plan_name: item.name,
                    status: is_collect,//1:收藏 0:取消收藏
                    id: item.id
                };
                postPlanlaborCollectplan(param).then((response)=>{
                    if (response.data.code == 200) {
                        if(index >= 0) {
                            this.plan_ranking_list[index].is_collect = is_collect;
                        }
                        if(item.index !== undefined) {
                            this.plan_list[item.index].is_collect = is_collect;
                        }
                        this.$message({
                            message: response.data.msg,
                            type: 'success'
                        });
                    }else {
                        this.$message.error(response.data.msg);
                    }
                });
            },
            clickCollectClear(item,index) {
                //收藏列表 - 取消收藏
                let param = {
                    loty: this.lottery.loty,
                    plan_name: item.plan_name,
                    status: 0,
                    id: item.collect_id
                };
                postPlanlaborCollectplan(param).then((response)=>{
                    if (response.data.code == 200) {
                        this.collect_list.splice(index,1);
                        this.$message({
                            message: response.data.msg,
                            type: 'success'
                        });
                    }else {
                        this.$message.error(response.data.msg);
                    }
                });
            },
            getPlanlaborIndex(loty) {
                getPlanlaborIndex(loty);
            },
            getPlanlabor(loty) {
                //获取全部计划
                getPlanlabor(loty,0).then((response)=>{
                    if (response.data.code == 200) {
                        this.plan_ranking_list = [];
                        if(Array.isArray(response.data.data)) {
                            this.plan_list = response.data.data;
                            if(this.plan_list.length > 0) {
                                this.paging.page = 1;
                                //总条数
                                this.paging.total = this.plan_list.length;
                                //总页数
                                this.paging.count = Math.ceil(this.paging.total / this.paging.limit);
                                //开始下标
                                this.paging.begin_index = 0;
                                //结束下标
                                this.paging.end_index = this.paging.limit;
                                this.plan = this.plan_list[0];
                                this.plan_active_index = 0;
                                this.getPlanlaborDetail();
                                this.plan_list.forEach((element,index) => {
                                    element.index = index;
                                    this.plan_ranking_list.push(element);
                                });
                                
                                //排行榜排序
                                function sortData(a, b) {
                                    return b.click_num - a.click_num;
                                }
                                this.plan_ranking_list.sort(sortData);
                                return;
                            }
                        }                        
                    }else {
                        this.$message.error(response.data.msg);
                    }
                    this.plan_list = [];
                    this.plan_ranking_list = [];
                    this.detail_list = [];
                    this.detail_list_all = [];
                    this.total = {};
                    this.paging.page = 0;
                    this.paging.total = 0;
                    this.paging.count = 0;
                })
            },
            clickPaging (type) {
                if(this.paging.count <= 1) {
                    return;
                }
                switch (type) {
                    case 'first':
                        if(this.paging.page == 1) {
                            return;
                        }
                        this.paging.begin_index = 0;
                        this.paging.end_index = this.paging.limit;
                        this.paging.page = 1;
                        return;
                    case 'last':
                        if(this.paging.page == this.paging.count || this.paging.count <= 1) {
                            return;
                        }
                        this.paging.begin_index = (this.paging.limit * this.paging.count) - this.paging.limit;
                        this.paging.end_index = this.paging.limit * this.paging.count;
                        this.paging.page = this.paging.count;
                        return;
                    case 'prev':
                        if(this.paging.page <= 1) {
                            return;
                        }
                        this.paging.begin_index = this.paging.begin_index - this.paging.limit;
                        this.paging.end_index = this.paging.end_index - this.paging.limit ;
                        --this.paging.page;
                        return;
                    case 'next':                        
                        if(this.paging.page == this.paging.count) {
                            return;
                        }
                        this.paging.begin_index = this.paging.begin_index + this.paging.limit;
                        this.paging.end_index = this.paging.end_index + this.paging.limit;
                        ++this.paging.page;
                        return;
                }
            },
            getPlanlaborDetail() {
                //获取计划详情
                getPlanlaborDetail(this.plan.id,this.lottery.loty,this.plan.name).then((response)=>{                    
                    if (response.data.code == 200) {
                        let list = response.data.data.list;
                        let options = response.data.data.count;
                        this.plan_wanfa_options = [];
                        this.plan_wanfa_value = '';
                        this.plan_wanfa_options.push({
                            label: '全部玩法',
                            value: ''
                        })
                        for (let index = 0; index < options.length; index++) {
                            this.plan_wanfa_options.push({
                                label: options[index].title,
                                value: options[index].title
                            })
                        }
                        this.detail_list = [];
                        this.detail_list_all = [];
                        if(list.length > 0) {
                            for (let index = list.length - 1; index >= 0; index--) {
                                if(list[index].randnum && list[index].randnum.split(',').length > 10) {
                                    //注数 > 10  按 多注 规则显示
                                    list[index].more = list[index].randnum.split(',').length;
                                }
                                if(list[index].opencode && list[index].opencode.length > 0) {
                                    //注数 > 10  按 多注 规则显示
                                    list[index].opencode = list[index].opencode.join("");
                                } else {
                                    list[index].opencode = "";
                                }
                                this.detail_list_all.push(list[index])
                                this.detail_list.push(list[index])
                            }
                            //复制号码
                            this.copy_number = list[0].randnum;
                            try {
                                //复制计划
                                this.copy_plan = JSON.stringify(this.detail_list.filter(item => Boolean(item.plan_name)));
                            } catch (error) {
                                console.log('copy_plan:',error)
                            }
                        }
                    }else {
                        this.$message.error(response.data.msg);
                    }
                })
            },
            filterPlanlaborDetail() { 
                //玩法过滤 
                this.detail_list = [];
                if(this.detail_list_all.length > 0) {
                    let list = this.detail_list_all;
                    
                    if (this.plan_wanfa_value == '') {
                        this.detail_list = list;
                    } else {
                        for (let index = 0; index < list.length; index++) {
                            if(list[index].scope && list[index].expect.indexOf(this.plan_wanfa_value) >= 0) {
                                this.detail_list.push(list[index])
                            }
                        }
                    }
                    //复制号码
                    this.copy_number = this.detail_list[this.detail_list.length - 1].randnum;
                    try {
                        //复制计划
                        this.copy_plan = JSON.stringify(this.detail_list);
                    } catch (error) {
                        console.log('copy_plan:',error)
                    }                            
                }
            },
            getPlanlaborCollect() {
                //收藏列表
                getPlanlaborCollect(this.lottery.loty).then((response)=>{
                    if (response.data.code == 200) {
                        this.collect_list = response.data.data.collect;
                        this.collect_list.forEach(element => {
                            element.quantity = get_random_num(100,9999)
                        });
                    }else {
                        this.collect_list = [];
                        this.$message.error(response.data.msg);
                    }
                })
            },
            clickCopy(type) {
                this.$copyText(type == 'plan' ? this.copy_plan : this.copy_number).then((e) => {
                    this.$message.success('复制成功')
                }, (e) => {
                    this.$message.error('复制失败')
                })
            } 
        },
        beforeDestroy() {
            //移除监听
            this.$eventBus.$off('lotteryIssue');
        }
    }
</script>

<style lang="scss">


</style>



// WEBPACK FOOTER //
// src/components/index/index.vue